export const SPONSORED_CTA_DATA_TEST = 'watch-ad-button'
export const SUBSCRIBE_CTA_DATA_TEST = 'subscribe-button'
